import { ConfigContext } from "shared/constants";
import { AppConfiguration } from "shared/types";

type Props = {
  config: AppConfiguration;
};

const ConfigProvider = ({
  config,
  children,
}: React.PropsWithChildren<Props>) => {
  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};

export default ConfigProvider;
